<template>
    <div>
        <BackButton />

        <b-alert variant="danger" show>Ansicht fürs Feedback muss noch umgesetzt werden.</b-alert>

        <CancelButton router-link="/ergebnisse" />
        <b-button to="/ergebnisse" type="submit" variant="primary">Senden</b-button>
    </div>
</template>

<script>
    import BackButton from "./helper-components/BackButton";
    import CancelButton from "./helper-components/CancelButton";

    export default {
        name: "Feedback",
        components: {CancelButton, BackButton}
    }
</script>

<style scoped>

</style>